"use strict";
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSegmentsGroupConfig = void 0;
const helpers_1 = require("../../../../utils/helpers");
const getSegmentsGroupConfig = (
// FIXME: Type this when there is a few more widgets implemented
_options = {}) => {
    // TODO These should be some configuration receive here to fine-tune the section's content
    return {
        type: 'group',
        path: 'segments',
        title: (t) => t(['customSurvey:segments:GroupTitle', 'segments:GroupTitle']),
        name: (t, _groupedObject, sequence) => t(['customSurvey:segments:GroupName', 'segments:GroupName'], { sequence }),
        showTitle: false,
        showGroupedObjectDeleteButton: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null);
            return segment !== null && segment['_sequence'] > 1;
        },
        showGroupedObjectAddButton: function (interview, path) {
            const segments = (0, helpers_1.getResponse)(interview, path, {});
            const segmentsArray = Object.values(segments).sort((segmentA, segmentB) => {
                return segmentA['_sequence'] - segmentB['_sequence'];
            });
            const segmentsCount = segmentsArray.length;
            const lastSegment = segmentsArray[segmentsCount - 1];
            return segmentsCount === 0 || (lastSegment && lastSegment.hasNextMode === true);
        },
        groupedObjectAddButtonLabel: (t, interview, path) => {
            const segments = (0, helpers_1.getResponse)(interview, path, {});
            const segmentsCount = Object.keys(segments).length;
            return t(['customSurvey:segments:AddButtonLabel', 'segments:AddButtonLabel'], { count: segmentsCount });
        },
        addButtonLocation: 'bottom',
        widgets: [
            // TODO Those widget names do not link to anything! They should accompany their actual widgets somewhere
            // Hard-coded, mandatory questions
            'segmentSameModeAsReverseTrip',
            'segmentModePre',
            'segmentMode',
            'segmentHasNextMode'
            // TODO Add more configurable widgets here, either custom or depending on the segments section configuration
        ]
    };
};
exports.getSegmentsGroupConfig = getSegmentsGroupConfig;
//# sourceMappingURL=groupSegments.js.map